import * as React from 'react';
/**
 *
 * Original name: early bird
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A365
 *
 */
export const EarlyBirdPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M43 30v-5.667L48 21l-5.058-3.372C42.442 11.489 38.518 8 32 8c-6.99 0-11 4.01-11 11v14.172L17.828 30H8v2c0 15.477 8.523 24 24 24s24-8.523 24-24v-2H43ZM32 12c4.775 0 7 2.225 7 7v11h-8.828L25 35.172V19c0-4.775 2.225-7 7-7Zm0 40c-12.587 0-19.288-6.054-19.946-18h4.118L24 41.828 31.828 34h20.118C51.288 45.946 44.587 52 32 52Z", fill: "currentColor" }),
    React.createElement("path", { d: "M32 22a2.321 2.321 0 0 0 2.5-2.5A2.321 2.321 0 0 0 32 17a2.321 2.321 0 0 0-2.5 2.5A2.321 2.321 0 0 0 32 22Z", fill: "currentColor" })));
